import { Dialog } from "components/dialog";
import { FC } from "react";
import { FileSystemItem } from "types";
import FileView from "views/library/file-or-folder-view/components/FileView";
import { useTranslation } from "react-i18next";

interface PreviewDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onClose: () => void;
  file: FileSystemItem | null;
  page: number | null;
}

export const PreviewDialog: FC<PreviewDialogProps> = ({
  isOpen,
  setIsOpen,
  onClose,
  file,
  page,
}) => {
  const { t } = useTranslation();

  if (!isOpen || !file) {
    return null;
  }
  return (
    <Dialog
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onClose={onClose}
      header={t("library.documentInfo")}
      headerClassName="sm:px-4 px-2 py-3 !border-none !mb-0"
      className="!h-screen !max-h-[100vh] !w-[90vw] !max-w-[90vw] !p-0"
    >
      <FileView file={file} page={page} />
    </Dialog>
  );
};
